module.exports = __webpack_public_path__ + "media/stylesheets/images/star-rating/star-empty-1b07da2faa82f28b17424ffd4ad6786e.svg";